import React from "react";

const ITEMS = [
  "Communauté bienveillante",
  "Données protégées",
  "Hébergé en France",
  "Modération humaine",
];

export default function Trust() {
  return (
    <section
      data-testid="trust-section"
      aria-label="Nos engagements"
      className="border-y border-[rgba(10,10,10,0.06)] bg-white"
    >
      <div className="mx-auto max-w-[1280px] px-5 md:px-8 py-6 md:py-8 flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
        {ITEMS.map((t, i) => (
          <div
            key={t}
            className="flex items-center gap-2 text-[13px] md:text-[14px] text-[#6B6660] font-medium"
          >
            <span
              className={`w-1.5 h-1.5 rounded-full ${
                i === 0 ? "bg-[#D97757]" : "bg-[#0A0A0A]/25"
              }`}
              aria-hidden="true"
            />
            {t}
          </div>
        ))}
      </div>
    </section>
  );
}
